import Joi from 'joi';
import { ElaasIdentifierCriteriaType } from './ElaasIdentifierCriteriaType';

export type ElaasIdentifierCriterion = {
  identifier: string;
  type?: ElaasIdentifierCriteriaType; // Defaults to ElaasIdentifierCriteriaType.ANY
  outcomes: string[];
};

const identifierCriterionSchema = Joi.object({
  identifier: Joi.string().required(),
  type: Joi.string().optional(),
  outcomes: Joi.array().items(Joi.string()).required(),
});

const isOfType = (obj: unknown): obj is ElaasIdentifierCriterion => !identifierCriterionSchema.validate(obj).error;

export const ElaasIdentifierCriterion = {
  isOfType,
};
